module.exports = __webpack_public_path__ + "static/webstorm2-4ff8ebdeae4c9395ad0a3639f1aa071f.png";